module.exports = __webpack_public_path__ + "img/HC3P_Screenshot_Cover_1.5f6cb922.jpg";